import TokenPair from '@square/dashboard-data/models/squareup/common/token/token-pair';
import { attr, ProtoBaseModel } from '@square/dashboard-data/utils/ember-model-stubs';
import CatalogObjectReference from '@square/dashboard-items-data/models/invoices/cart/catalog-object-reference';
import { ApplicationScope } from '@square/dashboard-items-data/models/invoices/enums';
import UUID from 'uuid-js';
const DiningOption = ProtoBaseModel.extend({
  id: attr(String),
  name: attr(String),
  ordinal: attr(Number),
  catalogObjectReference: attr(CatalogObjectReference)
});
const MerchantCatalogObjects = ProtoBaseModel.extend({});
const BackingDetails = ProtoBaseModel.extend({
  diningOption: attr(DiningOption),
  merchantCatalogObjects: attr(MerchantCatalogObjects)
});
const DiningOptionLineItem = ProtoBaseModel.extend({
  diningOptionLineItemTokenPair: attr(TokenPair),
  backingDetails: attr(BackingDetails),
  applicationScope: attr(ApplicationScope),
  clone() {
    const diningOptionLineItemClone = DiningOptionLineItem.deserialize(DiningOptionLineItem.serialize(this));
    diningOptionLineItemClone.set('diningOptionLineItemTokenPair', TokenPair.create({
      clientToken: UUID.create().toString()
    }));
    return diningOptionLineItemClone;
  }
});
export default DiningOptionLineItem;